import { render } from "./codeLogin.vue?vue&type=template&id=6aca1dc5&scoped=true"
import script from "./codeLogin.vue?vue&type=script&lang=js"
export * from "./codeLogin.vue?vue&type=script&lang=js"

import "./codeLogin.vue?vue&type=style&index=0&id=6aca1dc5&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aca1dc5"]])

export default __exports__